<template>
  <div id="sidebar-wrapper">
    <ul id="sidebar_menu" class="sidebar-nav">
      <li class="sidebar-brand">
        <label v-bind:class="{ active: status == 'online' }">
          <i class="fas fa-circle fa-sm online"></i>
        </label>
        <label v-bind:class="{ active: status == 'busy' }">
          <i class="fas fa-circle fa-sm busy"></i>
        </label>
        <label v-bind:class="{ active: status == 'offline' }">
          <i class="fas fa-circle fa-sm offline"></i>
        </label>
      </li>
    </ul>
    <ul class="sidebar-nav" id="sidebar">
      <li :class="{ active: $route.name == 'ListContact' }">
        <router-link :to="{ name: 'ListContact' }">
          <i class="fas fa-user fa-2x"></i>
        </router-link>
      </li>
      <li :class="{ active: $route.name == 'ListChat' }">
        <router-link :to="{ name: 'ListChat' }">
          <i class="fas fa-comment-alt fa-2x"></i>
        </router-link>
        <span class="badge" v-show="msgCount != 0">{{ msgCount }}</span>
      </li>
      <!-- <li :class="{active: $route.name == 'ListContact'}"><a href="Contact"><i class="fas fa-user  fa-2x"></i> </a></li>
      <li :class="{active: $route.name == 'ListChat'}"><a href="ChatApp"><i class="fas fa-comment-alt  fa-2x"></i> <span class="badge" v-show="numCount != 0">{{numCount}}</span></a></li>-->
      <!-- <li><span style="color:white">v0.0.1</span></li> -->
      <template v-if="$store.state.chat.serverConfig.assign_customer == 'pull_by_reservation'">
        <li style="color:#95eeab">ลูกค้าใหม่</li>
        <li
          class="nav-new-cust"
          :class="newCustomerClass"
          @click="getNextCustomer"
        >
          <i class="fas fa-comment-alt fa-2x"></i>
          <span class="new-customer-badge">N</span>
        </li>
      </template>
    </ul>  
    <ul v-if="showNoti" style="padding:6px 2px;display: flex; flex-direction: column; align-items: center;">
      <input class="uk-checkbox" style="margin-bottom: 8px;"
        type="checkbox"
        @change="setNoti"
        v-model="allowNoti"
      />
      <span style="color:#ffffff">แจ้งเตือน</span>
    </ul>
    <ul
      id="sidebar_menu"
      class="sidebar-nav"
      style="margin-top: 36px; font-size: 12px;"
    >
      <li><span style="color:white">v{{ appVersion }}</span></li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { version } from '../../package.json';

let checkNewCustomerInterval = undefined;

export default {
  name: 'Sidebar',
  data() {
    return {
      newCustomerClass: { newCust: false, newCustActive: false },
      showNoti: false,
      allowNoti: false,
      appVersion: version,
    };
  },
  computed: {
    ...mapGetters('profile', ['profile', 'status']),
    ...mapGetters('chat', ['msgCount', 'msgCountNotHold']),
  },
  methods: {
    setNoti() {
      this.$store.dispatch('chat/setReceiveNewCustNoti', String(this.allowNoti).toLowerCase());
    },
    async getNextCustomer() {
      if (this.$store.state.chat.hasNewCustomer == false) {
        return;
      }

      const handleNoReplyCustomerCount = await this.$store.dispatch(
        'chat/getHandleNoReplyCustomerCount',
      );
      await this.$store.dispatch('chat/getNextNewCustomerUnread'); // refesh list.
      const vm = this;
      function alertReply(customers) {
        vm.$message({
          type: 'warning',
          dangerouslyUseHTMLString: true,
          duration: 5000,
          iconClass: 'el-icon-info',
          message: `<p style="color: #ff0000; font-weight: bold;">กรุณาตอบกลับลูกค้า ก่อนรับลูกค้าใหม่</p>${
            customers
              ? `<ul style="margin: 14px 4px; list-style: none;">${customers.map(
                  c =>
                    `<li style="color: #090909; background-color: #ffffff; padding: 4px; margin-bottom: 4px;">${
                      c.customerImage
                        ? `<img style="border-radius: 50%; margin-right: 8px;" load="lazy" src="${c.customerImage}" width="32" height="32" />`
                        : ''
                    }
                    ${c.displayName || c.customerDisplayName}</li>`,
                )}</ul>`
              : ''
          }`,
        });
      }
      // เช็คเงื่อนไขที่กดรับลูกค้าไม่ได้
      // ถ้า filter ลูกค้าตัวเองจะเช็ค msgcount ก่อน
      // if (
      //   this.$store.state.chat.customerSelf == true &&
      //   this.msgCountNotHold > handleNoReplyCustomerCount
      // ) {
      //   // this.needCheckMessage = true;
      //   alertReply();
      //   return;
      // }
      // ไม่เช็ค msgCount แล้ว ให้ alert list customer ทุก case

      // ถ้าเป็นลูกค้าทั้งหมดจะ load ข้อมูลมาเช็ค
      const selfCustomerNoReply = await this.$store.dispatch(
        'chat/getSelfCustomerNoReply',
      );
      if (selfCustomerNoReply.length > handleNoReplyCustomerCount) {
        // this.needCheckMessage = true;
        alertReply(selfCustomerNoReply.map(sc => sc.customer));
        return;
      }



      if (this.$route.name !== 'ListChat') {
        this.$store.commit('chat/pushNextCustomerOnLoad', true);
        this.$router.push({ name: 'ListChat' });
      } else {
        await this.$store.dispatch('chat/pushNextCustomerToChatList');
      }
    },
    recheckNewCustomer() {
      return this.$store.dispatch('chat/getNextNewCustomerUnread');
    },
  },
  created() {
    const vm = this;
    this.$store.dispatch('chat/getNextNewCustomerUnread').then(function() {
      if (vm.$store.state.chat.newCustomerList.length > 0) {
        vm.$store.commit('chat/hasNewCustomer', true);
      }
    });
  },
  watch: {
    '$store.state.chat.hasNewCustomer': function(newValue) {
      this.newCustomerClass = { newCust: newValue, newCustActive: newValue };
      this.$store.dispatch('chat/getNextNewCustomerUnread');
    },
  },
  mounted() {
    console.log('--- mounted Sidebar ---');
    const vm = this;
    this.$store.dispatch('chat/init'); // สร้างขึ้นมาทีหลัง สำหรับ init data

    checkNewCustomerInterval = setInterval(async function() {
      await vm.$store.dispatch('chat/getNextNewCustomerUnread');
      if (vm.$store.state.chat.newCustomerList.length > 0) {
        vm.$store.commit('chat/hasNewCustomer', true);
      }
    }, 60000);
    vm.allowNoti = localStorage.getItem('receiveNewCustNoti') === 'true';
    const url = window.location.href;
    if (
      (url.includes('localhost') || /^https/.test(url)) &&
      window === window.parent
    ) {
      // check https and not in iframe
      this.showNoti = true;
    }
  },
  beforeDestroy() {
    if (checkNewCustomerInterval) {
      clearInterval(checkNewCustomerInterval);
    }
  },
};
</script>

<style scoped>
.sidebar-nav li.active a {
  color: #fff;
  text-decoration: none;
}
#sidebar-wrapper {
  width: 65px;
}

.sidebar-nav li.sidebar-brand label {
  color: gray;
}

#sidebar_menu li a,
.sidebar-nav li a {
  width: 65px;
}

label .online {
  border: 1px solid rgba(31, 161, 133, 0.8);
  border-radius: 8px;
  color: gray;
}

label .offline {
  border: 1px solid #e80e0e;
  border-radius: 8px;
  color: gray;
}

label .busy {
  border: 1px solid #ff7300;
  border-radius: 8px;
  color: gray;
}

label.active .online {
  border: 1px solid rgba(31, 161, 133, 0.8);
  border-radius: 8px;
  color: rgba(31, 161, 133, 0.8);
}

label.active .offline {
  border: 1px solid #e80e0e;
  border-radius: 8px;
  color: #e80e0e;
}

label.active .busy {
  border: 1px solid #ff7300;
  border-radius: 8px;
  color: #ff7300;
}
.nav-new-cust {
  display: block;
  position: relative;
}
.newCust {
  /* border-radius: 12px;
  padding: 0px 3px; */
  /* font-size: 13px;
  font-weight: bold; */
}
.newCustActive {
  color: #ffffff;
  cursor: pointer;
}
.nav-new-cust .new-customer-badge {
  display: none;
  position: absolute;
  top: -20px;
  right: 8px;
  color: #ff0000;
  font-weight: bold;
}
.newCustActive .new-customer-badge {
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue